import { useCallback, useState, useEffect } from 'react';
import useTombFinance from './useTombFinance';
import { Contract } from '@ethersproject/contracts';
import { BigNumber } from 'ethers';
import config from '../config';
import { Bank } from '../tomb-finance';
import { getDisplayBalance } from '../utils/formatBalance';

const useElysiumTokenPerSecond = (bank: Bank) => {
  const tombFinance = useTombFinance();
  const [tokenPerSecond, setTokenPerSecond] = useState<string>();

  const fetchTokenPerSecond = useCallback(async () => {
    const value = await tombFinance.getElysiumTokenPerSecond(bank);
    setTokenPerSecond(getDisplayBalance(value, 18));
  }, [tombFinance, bank]);

  useEffect(() => {
    fetchTokenPerSecond().catch((err) => console.error(`Failed to fetch token per second: ${err.stack}`));
    const refreshInterval = setInterval(fetchTokenPerSecond, config.refreshInterval);
    return () => clearInterval(refreshInterval);
  }, [fetchTokenPerSecond]);

  return tokenPerSecond;
};

export default useElysiumTokenPerSecond; 